import {Exclude, Type} from 'class-transformer';

import {TranslatedText} from 'shared/models/translated-text';
import {AnswerOption} from './answer-option';
import {QuestionType} from './question-type';

export class ButtonListQuestionType implements QuestionType {
  public name: string = 'buttonList';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Button Liste';
  @Exclude({toPlainOnly: true})
  public icon: string = 'bars';
  @Type(() => TranslatedText)
  // class-transformer doesn't work with generics
  // tslint:disable-next-line:array-type
  public buttons: TranslatedText[] = [];

  public getAnswerOptions(): Array<AnswerOption> {
    return this.buttons.map((button: TranslatedText, index: number) => {
      return {
        label: button.de,
        value: index,
      };
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/button-list-question-type.ts